import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class PreviewService {
    
  constructor(private _http: HttpClient) { }

    getdetail(data) {
        return this._http.post(environment.api_url+'product/preview',data);
    }

}
